export const skills = [
  {
    category: "Frontend",
    items: [
      { name: "HTML5", level: 90 },
      { name: "CSS3", level: 85 },
      { name: "JavaScript", level: 80 },
      { name: "React", level: 85 },
      { name: "TypeScript", level: 70 }
    ]
  },
  {
    category: "Backend",
    items: [
      { name: "Node.js", level: 75 },
      { name: "Express", level: 70 },
      { name: "PHP", level: 65 },
      { name: "Sql", level: 60 }
    ]
  },
  {
    category: "Tools",
    items: [
      { name: "Git", level: 80 },
      { name: "Postman", level: 70 },
      { name: "Figma", level: 60 }
    ]
  },
  {
    category: "Languages",
    items: [
      { name: "Python", level: 75 },
      { name: "Java", level: 70 },
      { name: "C++", level: 65 }
    ]
  },
  {
    category: "Database",
    items: [
      { name: "MongoDB", level: 65 },
      { name: "PostgreSQL", level: 70 },
      { name: "MySQL", level: 75 }
    ]
  }
];